import { ExpenseStatus, Roles } from './types/types';
export const BILLING_THRESHOLD = 1000; // don't prorate under 10.00 CHF/EUR/USD/GBP (value in minor units, e.g., cents)
export const CURRENCIES = ['CHF', 'EUR', 'USD', 'GBP'] as const;
export type Currency = (typeof CURRENCIES)[number];
export const roles: Roles[] = ['user', 'manager'];
export const statusOrder: Record<ExpenseStatus, number> = {
  overdue: 1,
  rejected: 2,
  open: 3,
  approving: 4,
  approved: 5,
  done: 6,
};
export type Language = 'de' | 'en';
export type Category =
  | 'ACCOMMODATION'
  | 'AIRFARE'
  | 'CAR_RENTAL'
  | 'FOOD'
  | 'FUEL'
  | 'GIFTS'
  | 'INTERNET'
  | 'LAUNDRY'
  | 'MEALS'
  | 'PARKING'
  | 'PHONE'
  | 'TAXI'
  | 'TRAIN'
  | 'OTHER';

export const CATEGORIES: Category[] = [
  'ACCOMMODATION',
  'AIRFARE',
  'CAR_RENTAL',
  'FOOD',
  'FUEL',
  'GIFTS',
  'INTERNET',
  'LAUNDRY',
  'MEALS',
  'PARKING',
  'PHONE',
  'TAXI',
  'TRAIN',
  'OTHER',
];

export const CATEGORIESi18: Record<Category, { en: string; de: string }> = {
  ACCOMMODATION: {
    en: 'Accommodation',
    de: 'Unterkunft',
  },
  AIRFARE: {
    en: 'Airfare',
    de: 'Flug',
  },
  CAR_RENTAL: {
    en: 'Car rental',
    de: 'Autovermietung',
  },
  FOOD: {
    en: 'Food',
    de: 'Essen',
  },
  FUEL: {
    en: 'Fuel',
    de: 'Treibstoff',
  },
  GIFTS: {
    en: 'Gifts',
    de: 'Geschenke',
  },
  INTERNET: {
    en: 'Internet',
    de: 'Internet',
  },
  LAUNDRY: {
    en: 'Laundry',
    de: 'Wäsche',
  },
  MEALS: {
    en: 'Meals',
    de: 'Mahlzeiten',
  },
  PARKING: {
    en: 'Parking',
    de: 'Parken',
  },
  PHONE: {
    en: 'Phone',
    de: 'Telefon',
  },
  TAXI: {
    en: 'Taxi',
    de: 'Taxi',
  },
  TRAIN: {
    en: 'Train',
    de: 'Zug',
  },
  OTHER: {
    en: 'Other',
    de: 'Sonstiges',
  },
};
export const COMMENT_MAX_LENGTH = 60;
export const DEBOUNCE_DELAY = 500;
